/**
 * This custom hook provides the functionality to save a user with the given parameters.
 */

import {useContext, useState} from "react";
import {FirebaseAuthContext} from "../../../firebase/FirebaseAuthProvider";
import {firebaseService} from "../../../firebase/Firebase";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useEditProfile = () => {
    const [saveInProgress, setSaveInProgress] = useState(false)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const history = useHistory();

    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    const saveUser = async (user) => {
        setSaveInProgress(true)

        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/profile', {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idToken: idToken,
                userData: user
            })
        }).then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            /*
              It might be the case that auth-relevant profile data is updated (i.e. role scopes) - therefore force a token refreshment.
              This has the advantage that the current scope is immediately set and no login/logout is necessary to make the changes effective.
             */
            firebaseService.auth().currentUser.getIdToken(true);

            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.profile.messages.edit.success',
                    defaultMessage: 'Profile of user {firstName} {secondName} saved.'
                }, {firstName: user.firstName, secondName: user.secondName}), {
                    variant: 'success',
                    preventDuplicate: true,
                    autoHideDuration: 3000
                });
            history.push('/common/profile');
        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.profile.messages.edit.error',
                    defaultMessage: 'Something went wrong while saving the profile data: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        }).finally(() => {
            setSaveInProgress(false)
        })
    }

    const cancel = () => {
        history.push('/common/profile');
    }

    return {saveUser, saveInProgress, cancel}
}
export default useEditProfile;